import React, { useEffect, useState, useRef } from "react"
import _ from "lodash"
import NumberField from "components/NumberField"
import { Formik, Form } from "formik"
import ReactSelect from "components/ReactSelect"
import * as Yup from "yup"
import submitData from "helpers/submitData"
import { toast } from "react-toastify"
import helpers from "helpers/helpers"

const CoPilotTexting = (props) => {
	const fields = {
		phone: "",
	}

	const validation = () => {
		if (props.models) {
			return Yup.object().shape({
				phone: Yup.string()
					.min(10, "Phone number must be 10 digits")
					.max(10, "Phone number must be 10 digits")
					.required("Required"),
				model: Yup.number().moreThan(0).required("Required"),
			})
		}
		return Yup.object().shape({
			phone: Yup.string()
				.min(10, "Phone number must be 10 digits")
				.max(10, "Phone number must be 10 digits")
				.required("Required"),
		})
	}

	const fieldStatus = (id, f) => {
		const classNames = require("classnames")

		return classNames("form__listItem !mt-0", {
			"form__fieldGroup--error": f.errors[id] && f.touched[id],
			"form__fieldGroup--success": !f.errors[id] && f.values[id],
		})
	}
	return (
		<div className="">
			<Formik
				enableReinitialize
				initialValues={fields}
				validationSchema={validation}
				validateOnMount={true}
				onSubmit={(values) => {
					values.action = "coPilotModelText"
					values.property = props.property
					if(props.welcomeCenter) values.welcomeCenter = true
					else values.welcomeCenter = false
					submitData("mainIngest", values).then((data) => {
						//return
						toast.success(data.message)
					})
				}}>
				{(f) => (
					<div className="pt-3 pb-1 px-4 bg-white rounded-lg">
						<h3 className="mb-4">Text Prospect for Traffic</h3>
						<Form>
							{/* console.log(f) */}
							<ul className="form__list items-center justify-between">
								{props.models && (
									<li className={fieldStatus("model", f, false, false, false)}>
										<label htmlFor="model">
											Model <sup>*</sup>
										</label>
										{f.errors.model && f.touched.model && (
											<div className="form__message">{f.errors.model}</div>
										)}
										<ReactSelect
											name={`model`}
											options={props.models}
											value={f.values.model}
											onBlur={f.setFieldTouched}
											onChange={f.setFieldValue}
										/>
									</li>
								)}
								<li className={fieldStatus("phone", f)}>
									<label htmlFor="phone">
										Phone <sup>*</sup>
									</label>
									{f.errors.phone && f.touched.phone && (
										<div className="form__message">{f.errors.phone}</div>
									)}
									<NumberField
										name={"phone"}
										value={f.values.phone}
										format="+1 (###) ###-####"
										type="text"
										className="form__input"
										onChange={(old, v) => f.setFieldValue("phone", v)}
										onBlur={() => {}}
									/>
								</li>
								<li>
									<input type="submit" value="Submit" className={helpers.submitClasses(f.isValid)} />
								</li>
							</ul>
						</Form>
					</div>
				)}
			</Formik>
		</div>
	)
}

export default CoPilotTexting
